module.exports = __webpack_public_path__ + "ipetbooking/admin/img/default_room.5b772077.jpg";